import { AxiosError } from 'axios'
import { post } from 'lib/api'
import { useRef, useState } from 'react'
import toast from 'react-hot-toast'

export default function Upload(props: {
  event: any
  onClickFaceMatch: () => void
  onClickStories: () => void
}) {
  const imageInputRef = useRef<HTMLInputElement>(null)
  const videoInputRef = useRef<HTMLInputElement>(null)
  const voiceInputRef = useRef<HTMLInputElement>(null)

  const [isUploading, setIsUploading] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)

  const onImageUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (file && props.event?.uuid) {
      setIsUploading(true)

      const formData = new FormData()

      formData.append('file', file)
      formData.append('type', 'image')
      formData.append('connection_type', 'event')
      formData.append('connection_id', props.event?.uuid)

      try {
        await post('/media/upload', formData)

        setIsUploading(false)
        setIsSuccess(true)
        imageInputRef.current!.value = ''
      } catch (e) {
        const error = e as AxiosError

        if (error.response) {
          const data = error.response.data as {
            error: {
              status: number
              message: string
            }
          }

          toast.dismiss()

          toast.error(data.error.message)
        }
      }
    }
  }

  const onVideoUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (file && props.event?.uuid) {
      setIsUploading(true)

      const formData = new FormData()

      formData.append('file', file)
      formData.append('type', 'video')
      formData.append('connection_type', 'event')
      formData.append('connection_id', props.event?.uuid)

      try {
        await post('/media/upload', formData)

        setIsUploading(false)
        setIsSuccess(true)
        videoInputRef.current!.value = ''
      } catch (e) {
        const error = e as AxiosError

        if (error.response) {
          const data = error.response.data as {
            error: {
              status: number
              message: string
            }
          }

          toast.dismiss()

          toast.error(data.error.message)
        }
      }
    }
  }

  const onVoiceUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (file && props.event?.uuid) {
      setIsUploading(true)

      const formData = new FormData()

      formData.append('file', file)
      formData.append('type', 'audio')
      formData.append('connection_type', 'event')
      formData.append('connection_id', props.event?.uuid)

      try {
        await post('/media/upload', formData)

        setIsUploading(false)
        setIsSuccess(true)
        voiceInputRef.current!.value = ''
      } catch (e) {
        const error = e as AxiosError

        if (error.response) {
          const data = error.response.data as {
            error: {
              status: number
              message: string
            }
          }

          toast.dismiss()

          toast.error(data.error.message)
        }
      }
    }
  }

  return (
    <div>
      <input
        ref={imageInputRef}
        type="file"
        accept="image/*"
        className="hidden"
        onChange={onImageUpload}
      />
      <input
        ref={videoInputRef}
        type="file"
        accept="video/*"
        className="hidden"
        onChange={onVideoUpload}
      />
      <input
        ref={voiceInputRef}
        type="file"
        accept=".wav,.aif,.aiff,.flac,.alac,.aac,.ogg,.mp3"
        className="hidden"
        onChange={onVoiceUpload}
      />

      {isUploading && (
        <div className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[calc(100%-80px)] bg-[#0B0B0B] rounded-[16px] flex flex-col items-center justify-center pt-[34px] pb-[24px] z-50">
          <div className="mb-[16px]">
            <svg
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M38.8708 1.16397C37.8703 0.137196 36.3897 -0.245326 35.0092 0.157329L2.81599 9.51905C1.3594 9.92372 0.326974 11.0854 0.0488603 12.5611C-0.235256 14.063 0.75715 15.9696 2.05368 16.7668L12.1198 22.9536C13.1522 23.5878 14.4848 23.4288 15.3391 22.5671L26.8658 10.9686C27.4461 10.3646 28.4065 10.3646 28.9867 10.9686C29.5669 11.5525 29.5669 12.4987 28.9867 13.1027L17.44 24.7032C16.5836 25.5628 16.4236 26.9016 17.0538 27.9405L23.2043 38.1075C23.9246 39.3155 25.1651 40 26.5257 40C26.6858 40 26.8658 40 27.0259 39.9799C28.5865 39.7785 29.8271 38.7115 30.2872 37.2015L39.8311 5.04958C40.2513 3.68056 39.8712 2.19073 38.8708 1.16397Z"
                fill="white"
              />
            </svg>
          </div>
          <div className="text-[18px] leading-[28px] text-white font-bold mb-[15px]">
            Yükleniyor...
          </div>
          <div className="text-[14px] leading-[16px] text-[#989898] mb-[36px] text-center">
            Bu işlem yüklediğiniz medya boyutuna göre biraz zaman alabilir.
          </div>
        </div>
      )}
      {isSuccess && (
        <div className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[calc(100%-80px)] bg-[#0B0B0B] rounded-[16px] flex flex-col items-center justify-center pt-[18px] pb-[24px] z-50">
          <div className="mb-[6px]">
            <svg
              width="94"
              height="94"
              viewBox="0 0 94 94"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M44.4286 1.542C46.0115 0.592791 47.9885 0.592792 49.5714 1.542L58.7949 7.07302C59.4438 7.46213 60.1725 7.69891 60.9262 7.76551L71.6392 8.71226C73.4777 8.87473 75.0772 10.0368 75.7999 11.7352L80.0108 21.6313C80.307 22.3275 80.7574 22.9474 81.328 23.4442L89.4385 30.5071C90.8304 31.7192 91.4414 33.5995 91.0277 35.3983L88.6176 45.8795C88.4481 46.6169 88.4481 47.3831 88.6176 48.1205L91.0277 58.6017C91.4414 60.4005 90.8304 62.2808 89.4385 63.4929L81.328 70.5558C80.7574 71.0526 80.307 71.6725 80.0108 72.3687L75.7999 82.2649C75.0772 83.9632 73.4777 85.1253 71.6392 85.2877L60.9262 86.2345C60.1725 86.3011 59.4438 86.5379 58.7949 86.927L49.5714 92.458C47.9885 93.4072 46.0115 93.4072 44.4286 92.458L35.2051 86.927C34.5562 86.5379 33.8275 86.3011 33.0738 86.2345L22.3608 85.2877C20.5223 85.1253 18.9228 83.9632 18.2001 82.2649L13.9892 72.3687C13.693 71.6725 13.2426 71.0526 12.672 70.5558L4.56148 63.4929C3.1696 62.2808 2.55865 60.4005 2.97226 58.6017L5.38235 48.1205C5.5519 47.3831 5.5519 46.6169 5.38235 45.8795L2.97226 35.3983C2.55865 33.5995 3.1696 31.7192 4.56149 30.5071L12.672 23.4442C13.2426 22.9474 13.693 22.3275 13.9892 21.6313L18.2001 11.7351C18.9228 10.0368 20.5223 8.87473 22.3608 8.71226L33.0738 7.76551C33.8275 7.69891 34.5562 7.46213 35.2051 7.07302L44.4286 1.542Z"
                fill="#1E1E1E"
              />
              <circle cx="47" cy="47" r="23" fill="white" />
              <path
                d="M42.38 52.94L35.285 45.845C34.68 45.24 33.91 44.9375 32.975 44.9375C32.04 44.9375 31.27 45.24 30.665 45.845C30.06 46.45 29.7575 47.22 29.7575 48.155C29.7575 49.09 30.06 49.86 30.665 50.465L40.07 59.87C40.73 60.53 41.5 60.86 42.38 60.86C43.26 60.86 44.03 60.53 44.69 59.87L63.335 41.225C63.94 40.62 64.2425 39.85 64.2425 38.915C64.2425 37.98 63.94 37.21 63.335 36.605C62.73 36 61.96 35.6975 61.025 35.6975C60.09 35.6975 59.32 36 58.715 36.605L42.38 52.94ZM47 80C42.435 80 38.145 79.1332 34.13 77.3996C30.115 75.666 26.6225 73.3153 23.6525 70.3475C20.6825 67.3775 18.3318 63.885 16.6004 59.87C14.869 55.855 14.0022 51.565 14 47C14 42.435 14.8668 38.145 16.6004 34.13C18.334 30.115 20.6847 26.6225 23.6525 23.6525C26.6225 20.6825 30.115 18.3318 34.13 16.6004C38.145 14.869 42.435 14.0022 47 14C51.565 14 55.855 14.8668 59.87 16.6004C63.885 18.334 67.3775 20.6847 70.3475 23.6525C73.3175 26.6225 75.6693 30.115 77.4029 34.13C79.1365 38.145 80.0022 42.435 80 47C80 51.565 79.1332 55.855 77.3996 59.87C75.666 63.885 73.3153 67.3775 70.3475 70.3475C67.3775 73.3175 63.885 75.6693 59.87 77.4029C55.855 79.1365 51.565 80.0022 47 80Z"
                fill="#55B755"
              />
            </svg>
          </div>
          <div className="text-[18px] leading-[28px] text-white font-bold mb-[15px]">
            Başarılı
          </div>
          <div className="text-[14px] leading-[16px] text-[#989898] mb-[36px]">
            Yükleme işlemin başarıyla tamamlandı.
          </div>
          <div>
            <div
              className="w-full bg-[#fff] text-[14px] leading-[22px] text-[#030303] font-bold rounded-[100px] px-[54px] py-[10px]"
              onClick={() => setIsSuccess(false)}
            >
              Devam
            </div>
          </div>
        </div>
      )}

      <div className="px-[30px] text-[13px] opacity-50 -mt-[15px]">
        Etkinliğin zaman kapsülüne <br />
        bir şeyler yükle!
      </div>

      <div className="flex items-center gap-[20px] px-[30px] py-[30px]">
        <div
          className="flex flex-col items-center gap-[10px]"
          onClick={() => imageInputRef.current?.click()}
        >
          <div className="flex items-center justify-center w-[50px] h-[50px] rounded-full border-[2px] border-[#666666]">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.26354 6.55527C7.26324 7.00225 6.90064 7.36435 6.45366 7.36405C6.00668 7.36375 5.64458 7.00116 5.64488 6.55418C5.64518 6.1072 6.00778 5.7451 6.45475 5.7454C6.90173 5.7457 7.26384 6.10829 7.26354 6.55527Z"
                fill="#ADADAD"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.69384 3.11726C7.98215 3.11611 5.64264 3.27162 4.18179 3.3838C3.70137 3.42069 3.32389 3.79766 3.28635 4.27803C3.1722 5.73873 3.01354 8.07803 3.01238 9.78972C3.01145 11.1624 3.11128 12.9388 3.20871 14.342L8.6856 9.96655C10.1286 8.81376 12.1874 8.85003 13.5889 10.0529L16.2867 12.3685C16.333 11.4764 16.3658 10.5733 16.3663 9.79873C16.3674 8.08703 16.2119 5.74753 16.0998 4.28668C16.0629 3.80626 15.6859 3.42878 15.2055 3.39124C13.7448 3.27708 11.4055 3.11842 9.69384 3.11726ZM17.4273 13.6607C17.5084 12.3996 17.5795 10.9647 17.5803 9.79954C17.5815 8.03629 17.4224 5.65526 17.3102 4.19372C17.2275 3.11678 16.3769 2.26509 15.3001 2.18093C13.8387 2.06673 11.4579 1.90446 9.69466 1.90327C7.9314 1.90208 5.55037 2.06113 4.08884 2.17337C3.0119 2.25607 2.16021 3.10662 2.07605 4.18345C1.96184 5.64483 1.79958 8.02564 1.79839 9.7889C1.7972 11.5522 1.95625 13.9332 2.06849 15.3947C2.15119 16.4717 3.00173 17.3234 4.07856 17.4075C5.53994 17.5217 7.92076 17.684 9.68401 17.6852C11.4473 17.6864 13.8283 17.5273 15.2898 17.4151C16.3668 17.3324 17.2185 16.4818 17.3026 15.405C17.3411 14.9124 17.3851 14.3153 17.4265 13.6726C17.4268 13.6686 17.427 13.6646 17.4273 13.6607ZM16.1956 13.8901L12.7982 10.9741C11.8393 10.1511 10.4306 10.1263 9.44333 10.915L3.44036 15.7108C3.43199 15.7174 3.4235 15.7239 3.4149 15.73C3.5722 15.9919 3.84916 16.1719 4.17315 16.1972C5.63385 16.3114 7.97314 16.47 9.68483 16.4712C11.3965 16.4723 13.736 16.3168 15.1969 16.2046C15.6773 16.1677 16.0548 15.7908 16.0923 15.3104C16.1247 14.8962 16.1606 14.4113 16.1956 13.8901Z"
                fill="#ADADAD"
              />
            </svg>
          </div>
          <div className="text-[#EEEEEE] text-[13px]">Fotoğraf</div>
        </div>
        <div
          className="flex flex-col items-center gap-[10px]"
          onClick={() => videoInputRef.current?.click()}
        >
          <div className="flex items-center justify-center w-[50px] h-[50px] rounded-full border-[2px] border-[#666666]">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.2258 9.79593C13.2266 8.59692 13.1256 6.99114 13.0418 5.87023C13.0068 5.40131 12.6458 5.03048 12.1831 4.98595C11.0518 4.8771 9.42315 4.74456 8.21273 4.74374C7.00232 4.74292 5.3735 4.87327 4.24204 4.9806C3.77924 5.0245 3.41779 5.39484 3.38213 5.86371C3.29688 6.98451 3.1937 8.59015 3.19289 9.78916C3.19208 10.9882 3.29309 12.5939 3.37683 13.7149C3.41186 14.1838 3.77281 14.5546 4.23555 14.5991C5.36687 14.708 6.9955 14.8405 8.20592 14.8413C9.41634 14.8422 11.0452 14.7118 12.1766 14.6045C12.6394 14.5606 13.0009 14.1903 13.0365 13.7214C13.1218 12.6006 13.225 10.9949 13.2258 9.79593ZM14.2424 5.77937C14.3263 6.9027 14.4306 8.54808 14.4297 9.79674C14.4289 11.0454 14.3224 12.6906 14.237 13.8139C14.1567 14.8686 13.3383 15.7114 12.2896 15.8109C11.1554 15.9184 9.47733 16.0539 8.2051 16.0531C6.93288 16.0522 5.25495 15.9145 4.12096 15.8053C3.07235 15.7045 2.25508 14.8605 2.17628 13.8057C2.09236 12.6824 1.9881 11.037 1.98894 9.78835C1.98978 8.53969 2.09626 6.89445 2.1817 5.77123C2.26192 4.71652 3.08033 3.87372 4.12908 3.77423C5.26322 3.66665 6.94133 3.53117 8.21355 3.53203C9.48577 3.53289 11.1637 3.67063 12.2977 3.77974C13.3463 3.88064 14.1636 4.72455 14.2424 5.77937Z"
                fill="#ADADAD"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.3573 6.05211C17.5347 6.16262 17.6426 6.3577 17.6424 6.56767L17.6381 13.0301C17.6379 13.2401 17.5298 13.435 17.3522 13.5453C17.1747 13.6556 16.953 13.6655 16.7665 13.5714L13.5571 11.9537C13.3532 11.8509 13.2245 11.641 13.2247 11.4115L13.2269 8.18031C13.227 7.95083 13.356 7.74113 13.56 7.63864L16.7716 6.02519C16.9583 5.93141 17.1799 5.9416 17.3573 6.05211ZM14.4306 8.55556L14.4289 11.0379L16.4348 12.049L16.4378 7.54716L14.4306 8.55556Z"
                fill="#ADADAD"
              />
            </svg>
          </div>
          <div className="text-[#EEEEEE] text-[13px]">Video</div>
        </div>
        <div
          className="flex flex-col items-center gap-[10px]"
          onClick={() => voiceInputRef.current?.click()}
        >
          <div className="flex items-center justify-center w-[50px] h-[50px] rounded-full border-[2px] border-[#666666]">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.71502 5.20077C8.88052 3.33843 10.4704 1.97226 12.3171 1.9735C14.1639 1.97475 15.7519 3.34307 15.9149 5.20563C16.0003 6.18105 16.0743 7.28874 16.0737 8.20377C16.0731 9.1188 15.9975 10.2264 15.9108 11.2017C15.7453 13.064 14.1555 14.4302 12.3087 14.429C10.462 14.4277 8.87396 13.0594 8.71097 11.1968C8.62561 10.2214 8.55157 9.11373 8.55218 8.1987C8.5528 7.28367 8.62834 6.17608 8.71502 5.20077ZM12.3161 3.46816C11.2141 3.46742 10.3073 4.27609 10.2135 5.33225C10.128 6.29453 10.0571 7.35069 10.0565 8.19972C10.0559 9.04874 10.1254 10.105 10.2096 11.0674C10.3021 12.1237 11.2078 12.9336 12.3097 12.9343C13.4117 12.9351 14.3185 12.1264 14.4124 11.0702C14.4979 10.1079 14.5688 9.05179 14.5694 8.20276C14.57 7.35373 14.5005 6.29748 14.4162 5.33509C14.3238 4.2788 13.4181 3.4689 12.3161 3.46816Z"
                fill="#ADADAD"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.29304 7.94739C5.70844 7.94767 6.04496 8.28249 6.04468 8.69523C6.04408 9.58838 6.11079 10.6234 6.21154 11.6718C6.50218 14.6962 9.1682 16.9179 12.3071 16.9201C15.4459 16.9222 18.1149 14.704 18.4096 11.68C18.5118 10.6318 18.5799 9.59684 18.5805 8.70368C18.5808 8.29095 18.9178 7.95658 19.3332 7.95686C19.7486 7.95714 20.0851 8.29196 20.0848 8.7047C20.0842 9.66431 20.0115 10.7515 19.9069 11.8241C19.5547 15.4381 16.5722 18.0528 13.0582 18.3801L13.0567 20.6572C13.0564 21.0699 12.7194 21.4043 12.304 21.404C11.8886 21.4038 11.5521 21.0689 11.5524 20.6562L11.5539 18.379C8.04042 18.047 5.06139 15.4283 4.71405 11.8139C4.61096 10.7411 4.53974 9.65382 4.54038 8.69421C4.54066 8.28148 4.87764 7.94711 5.29304 7.94739Z"
                fill="#ADADAD"
              />
            </svg>
          </div>
          <div className="text-[#EEEEEE] text-[13px]">Ses Kaydı</div>
        </div>
        <div
          className="flex flex-col items-center gap-[10px]"
          onClick={props.onClickFaceMatch}
        >
          <div className="flex items-center justify-center w-[50px] h-[50px] rounded-full border-[2px] border-[#D6FF00]">
            <svg
              width="24"
              height="24"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.28441 0.188965C8.54399 0.280327 8.75427 0.426797 8.84708 0.699433C9.01095 1.1838 8.6513 1.67106 8.11908 1.67976C7.70868 1.68701 7.29827 1.67976 6.88787 1.68121C6.19468 1.68121 5.50148 1.67106 4.80829 1.68556C3.07386 1.72037 1.71503 3.0763 1.68602 4.80928C1.66862 5.89838 1.68022 6.98747 1.68167 8.07802C1.68167 8.36661 1.58161 8.60444 1.33508 8.76541C0.934823 9.02644 0.414204 8.85097 0.23583 8.40141C0.219878 8.36226 0.202476 8.32455 0.186523 8.28685C0.186523 7.04113 0.186523 5.79541 0.186523 4.5497C0.195225 4.51344 0.206826 4.47719 0.211177 4.44093C0.402602 2.38456 1.8615 0.737138 3.88162 0.30063C4.1006 0.252773 4.32538 0.22522 4.54726 0.188965L8.28441 0.188965Z"
                fill="#D6FF00"
              />
              <path
                d="M24.82 0.188965C25.052 0.22667 25.2855 0.255674 25.5146 0.30498C27.5086 0.732787 28.9951 2.43241 29.156 4.46559C29.1705 4.65411 29.1778 4.84264 29.1792 5.03116C29.1807 6.06515 29.1821 7.09769 29.1792 8.13168C29.1792 8.49857 28.9284 8.80166 28.5803 8.87417C28.2453 8.94378 27.8973 8.76976 27.7595 8.44202C27.7102 8.32455 27.6899 8.18678 27.6899 8.05772C27.6841 7.01938 27.687 5.98104 27.687 4.94415C27.687 3.96237 27.3404 3.12851 26.6022 2.47447C26.0584 1.99156 25.4145 1.71312 24.688 1.69717C23.5568 1.67106 22.4228 1.68556 21.2916 1.68556C21.0016 1.68556 20.7638 1.5855 20.6042 1.33897C20.3432 0.938715 20.5187 0.418095 20.9682 0.239722C21.0074 0.223769 21.0451 0.207817 21.0828 0.190415C22.3285 0.190415 23.5742 0.190415 24.82 0.190415L24.82 0.188965Z"
                fill="#D6FF00"
              />
              <path
                d="M0.186523 21.0845C0.277886 20.825 0.424355 20.6147 0.698442 20.5219C1.18281 20.358 1.67152 20.7176 1.67877 21.2513C1.68602 21.7603 1.67877 22.2708 1.68022 22.7798C1.68022 23.3744 1.67152 23.969 1.68457 24.5636C1.72083 26.298 3.07676 27.6554 4.81264 27.6844C5.90174 27.7018 6.99228 27.6887 8.08283 27.6902C8.45553 27.6902 8.74267 27.8874 8.84853 28.205C9.00515 28.6807 8.65276 29.1766 8.14519 29.181C7.39979 29.1868 6.65439 29.1853 5.90899 29.181C5.42752 29.1781 4.94461 29.1911 4.46605 29.1549C2.43142 29.0011 0.733247 27.5103 0.303989 25.5163C0.254683 25.2872 0.225679 25.0523 0.187974 24.8217L0.187974 21.0845L0.186523 21.0845Z"
                fill="#D6FF00"
              />
              <path
                d="M22.9955 27.6875C23.5191 27.6875 24.044 27.6977 24.5676 27.6861C26.2933 27.6484 27.6521 26.2939 27.6826 24.5667C27.7014 23.4776 27.6869 22.3871 27.6884 21.2965C27.6884 20.9253 27.8711 20.6468 28.1829 20.5308C28.6382 20.3626 29.1705 20.6918 29.1748 21.1776C29.1835 22.419 29.2198 23.6618 29.1473 24.8988C29.0313 26.8653 27.6434 28.5054 25.7408 29.0057C25.3391 29.1116 24.9142 29.1667 24.4994 29.1754C23.4103 29.1986 22.3198 29.1856 21.2292 29.1827C20.8725 29.1827 20.5723 28.9303 20.4998 28.5866C20.4287 28.2487 20.6085 27.892 20.9406 27.7571C21.0508 27.7122 21.1785 27.6948 21.2988 27.6933C21.8644 27.6875 22.4314 27.6904 22.997 27.6904L22.997 27.6875L22.9955 27.6875Z"
                fill="#D6FF00"
              />
              <path
                d="M14.9268 23.585C12.7573 23.5864 11.0693 22.9556 9.63652 21.6504C9.28993 21.3343 9.24352 20.8731 9.53211 20.5425C9.81635 20.2147 10.2978 20.1915 10.643 20.5048C11.3231 21.124 12.0859 21.6084 12.9821 21.8303C15.082 22.3538 17.005 22.0275 18.6611 20.5555C18.896 20.3467 19.1454 20.2263 19.4587 20.3104C20.0344 20.4642 20.2244 21.182 19.7893 21.5924C18.9932 22.3451 18.0767 22.9005 17.0296 23.234C16.2683 23.4762 15.4881 23.5879 14.9268 23.585V23.585Z"
                fill="#D6FF00"
              />
              <path
                d="M16.2113 13.8514C16.2113 14.7099 16.2142 15.5684 16.2113 16.4269C16.2084 17.1273 15.9691 17.7176 15.3832 18.1367C15.0424 18.3803 14.6552 18.4876 14.2405 18.4978C14.0056 18.5036 13.7663 18.5123 13.5342 18.4818C13.1485 18.4296 12.873 18.0627 12.9049 17.6828C12.9368 17.2956 13.2558 16.9881 13.643 16.978C13.8083 16.9736 13.9736 16.978 14.139 16.9765C14.532 16.9722 14.6842 16.8199 14.6842 16.4226C14.6842 14.6722 14.6842 12.9218 14.6842 11.1714C14.6842 10.8741 14.7974 10.6377 15.0482 10.4797C15.2948 10.3245 15.5558 10.3158 15.8139 10.4608C16.0793 10.6102 16.2113 10.8437 16.2113 11.1467C16.2142 12.0473 16.2113 12.9493 16.2113 13.8499L16.2113 13.8514Z"
                fill="#D6FF00"
              />
              <path
                d="M8.06934 12.1705C8.06934 11.8398 8.06934 11.5106 8.06934 11.18C8.06934 10.8986 8.16505 10.6608 8.39708 10.494C8.81764 10.1938 9.39771 10.4433 9.50068 10.9653C9.50503 10.9885 9.51083 11.0118 9.51083 11.035C9.51083 11.7978 9.52823 12.562 9.50213 13.3248C9.48908 13.7164 9.14973 13.989 8.78428 13.9846C8.42173 13.9803 8.10559 13.6917 8.08384 13.3016C8.06208 12.926 8.07949 12.5475 8.07949 12.1705L8.07079 12.1705L8.06934 12.1705Z"
                fill="#D6FF00"
              />
              <path
                d="M20.029 12.1661C20.029 11.8035 20.0203 11.4395 20.0319 11.077C20.0421 10.742 20.2915 10.4476 20.5975 10.3809C21.0355 10.2866 21.4589 10.6158 21.4705 11.0944C21.4865 11.8151 21.485 12.5373 21.4705 13.2595C21.4618 13.6801 21.1239 13.9904 20.7338 13.9846C20.3466 13.9774 20.0392 13.6525 20.029 13.2276C20.0218 12.8738 20.0276 12.5199 20.0276 12.1661L20.0305 12.1661L20.029 12.1661Z"
                fill="#D6FF00"
              />
            </svg>
          </div>
          <div className="text-[#D6FF00] text-[13px]">Yüz Tanıma</div>
        </div>
      </div>
      <div className="p-[30px]">
        <div>Bu etkinlikte diğer yapabileceklerin</div>
        <div className="flex flex-col gap-[6px]">
          <div
            className="flex items-center gap-[15px] bg-[#D6FF00] px-[16px] py-[8px] rounded-2xl text-[#000]"
            onClick={props.onClickFaceMatch}
          >
            <div>
              <svg
                width="29"
                height="29"
                viewBox="0 0 29 29"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.09788 0C8.35747 0.0913622 8.56775 0.237832 8.66056 0.510468C8.82443 0.994833 8.46478 1.4821 7.93256 1.4908C7.52216 1.49805 7.11175 1.4908 6.70135 1.49225C6.00815 1.49225 5.31496 1.4821 4.62177 1.4966C2.88734 1.5314 1.5285 2.88734 1.4995 4.62032C1.4821 5.70941 1.4937 6.79851 1.49515 7.88905C1.49515 8.17764 1.39509 8.41547 1.14855 8.57645C0.7483 8.83748 0.22768 8.66201 0.0493066 8.21245C0.0333545 8.17329 0.0159521 8.13559 0 8.09788C0 6.85217 0 5.60645 0 4.36073C0.00870116 4.32448 0.0203027 4.28822 0.0246533 4.25197C0.216079 2.19559 1.67497 0.548173 3.69509 0.111665C3.91407 0.0638085 4.13885 0.0362548 4.36073 0H8.09788Z"
                  fill="black"
                />
                <path
                  d="M24.6334 0C24.8655 0.037705 25.0989 0.0667089 25.3281 0.116015C27.3221 0.543823 28.8085 2.24345 28.9695 4.27662C28.984 4.46515 28.9913 4.65367 28.9927 4.8422C28.9942 5.87618 28.9956 6.90872 28.9927 7.94271C28.9927 8.30961 28.7418 8.6127 28.3938 8.68521C28.0588 8.75482 27.7108 8.5808 27.573 8.25305C27.5237 8.13559 27.5034 7.99782 27.5034 7.86875C27.4976 6.83041 27.5005 5.79207 27.5005 4.75519C27.5005 3.7734 27.1539 2.93954 26.4157 2.28551C25.8719 1.80259 25.228 1.52415 24.5015 1.5082C23.3703 1.4821 22.2363 1.4966 21.1051 1.4966C20.8151 1.4966 20.5772 1.39654 20.4177 1.15C20.1567 0.74975 20.3322 0.229131 20.7817 0.0507568C20.8209 0.0348046 20.8586 0.0188525 20.8963 0.00145019C22.142 0.00145019 23.3877 0.00145019 24.6334 0.00145019V0Z"
                  fill="black"
                />
                <path
                  d="M0 20.8956C0.0913622 20.636 0.237832 20.4257 0.511918 20.3329C0.996283 20.169 1.485 20.5287 1.49225 21.0623C1.4995 21.5714 1.49225 22.0818 1.4937 22.5908C1.4937 23.1854 1.485 23.78 1.49805 24.3746C1.53431 26.109 2.89024 27.4664 4.62612 27.4954C5.71521 27.5128 6.80576 27.4998 7.89631 27.5012C8.26901 27.5012 8.55614 27.6984 8.66201 28.016C8.81863 28.4917 8.46623 28.9877 7.95866 28.992C7.21326 28.9978 6.46786 28.9964 5.72246 28.992C5.241 28.9891 4.75809 29.0022 4.27952 28.9659C2.2449 28.8122 0.546723 27.3214 0.117466 25.3274C0.0681591 25.0982 0.0391552 24.8633 0.00145019 24.6327V20.8956H0Z"
                  fill="black"
                />
                <path
                  d="M22.809 27.4985C23.3325 27.4985 23.8575 27.5087 24.381 27.4971C26.1068 27.4594 27.4656 26.1049 27.496 24.3777C27.5149 23.2886 27.5004 22.1981 27.5018 21.1075C27.5018 20.7363 27.6846 20.4579 27.9964 20.3418C28.4517 20.1736 28.9839 20.5028 28.9883 20.9886C28.997 22.23 29.0333 23.4728 28.9607 24.7098C28.8447 26.6763 27.4569 28.3165 25.5542 28.8168C25.1525 28.9226 24.7276 28.9777 24.3129 28.9864C23.2238 29.0096 22.1332 28.9966 21.0427 28.9937C20.6859 28.9937 20.3857 28.7414 20.3132 28.3977C20.2422 28.0598 20.422 27.703 20.7541 27.5682C20.8643 27.5232 20.9919 27.5058 21.1123 27.5043C21.6779 27.4985 22.2449 27.5014 22.8105 27.5014V27.4985H22.809Z"
                  fill="black"
                />
                <path
                  d="M14.7403 23.396C12.5708 23.3975 10.8828 22.7666 9.45 21.4615C9.10341 21.1453 9.057 20.6842 9.34559 20.3535C9.62983 20.0258 10.1113 20.0026 10.4564 20.3158C11.1366 20.935 11.8994 21.4194 12.7956 21.6413C14.8955 22.1648 16.8184 21.8385 18.4746 20.3666C18.7095 20.1577 18.9589 20.0374 19.2722 20.1215C19.8479 20.2752 20.0379 20.993 19.6028 21.4035C18.8067 22.1561 17.8901 22.7115 16.8431 23.0451C16.0817 23.2873 15.3015 23.3989 14.7403 23.396V23.396Z"
                  fill="black"
                />
                <path
                  d="M16.0248 13.6624C16.0248 14.5209 16.0277 15.3794 16.0248 16.2379C16.0219 16.9384 15.7826 17.5286 15.1967 17.9477C14.8559 18.1913 14.4687 18.2987 14.054 18.3088C13.819 18.3146 13.5797 18.3233 13.3477 18.2929C12.962 18.2407 12.6864 17.8738 12.7183 17.4938C12.7502 17.1066 13.0693 16.7992 13.4565 16.789C13.6218 16.7847 13.7871 16.789 13.9524 16.7876C14.3454 16.7832 14.4977 16.6309 14.4977 16.2336C14.4977 14.4832 14.4977 12.7328 14.4977 10.9824C14.4977 10.6851 14.6108 10.4488 14.8617 10.2907C15.1083 10.1355 15.3693 10.1268 15.6274 10.2718C15.8928 10.4212 16.0248 10.6547 16.0248 10.9578C16.0277 11.8584 16.0248 12.7604 16.0248 13.6609V13.6624Z"
                  fill="black"
                />
                <path
                  d="M7.88281 11.9815C7.88281 11.6508 7.88281 11.3217 7.88281 10.991C7.88281 10.7097 7.97853 10.4718 8.21056 10.3051C8.63111 10.0049 9.21119 10.2543 9.31415 10.7764C9.3185 10.7996 9.32431 10.8228 9.32431 10.846C9.32431 11.6088 9.34171 12.373 9.3156 13.1358C9.30255 13.5274 8.96321 13.8 8.59776 13.7957C8.23521 13.7913 7.91907 13.5027 7.89731 13.1126C7.87556 12.737 7.89296 12.3585 7.89296 11.9815H7.88426H7.88281Z"
                  fill="black"
                />
                <path
                  d="M19.8425 11.9771C19.8425 11.6146 19.8338 11.2506 19.8454 10.888C19.8556 10.553 20.105 10.2586 20.411 10.1919C20.8489 10.0977 21.2724 10.4268 21.284 10.9054C21.3 11.6262 21.2985 12.3484 21.284 13.0706C21.2753 13.4911 20.9374 13.8015 20.5473 13.7956C20.1601 13.7884 19.8527 13.4636 19.8425 13.0386C19.8353 12.6848 19.8411 12.331 19.8411 11.9771H19.844H19.8425Z"
                  fill="black"
                />
              </svg>
            </div>
            <div>
              <div className="text-[14px]">
                Yüz tanıma ile fotoğraflarına ulaş!
              </div>
              <div className="text-[11px] text-[#71757E]">
                Bir selfie bırak, içinde olduğun karelere ulaş!
              </div>
            </div>
          </div>
          <div
            className="flex items-center gap-[15px] bg-[rgba(255,255,255,0.06)] border border-[rgba(215,255,0,0.16)] px-[16px] py-[8px] rounded-2xl text-[#fff]"
            onClick={props.onClickStories}
          >
            <div>
              <svg
                width="29"
                height="29"
                viewBox="0 0 29 29"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M14.5003 6.70398C12.9603 6.70398 11.7119 7.96047 11.7119 9.51043C11.7119 11.0604 12.9603 12.3169 14.5003 12.3169C16.0404 12.3169 17.2888 11.0604 17.2888 9.51043C17.2888 7.96047 16.0404 6.70398 14.5003 6.70398ZM9.85289 9.51043C9.85289 6.92716 11.9336 4.83301 14.5003 4.83301C17.067 4.83301 19.1478 6.92716 19.1478 9.51043C19.1478 12.0937 17.067 14.1878 14.5003 14.1878C11.9336 14.1878 9.85289 12.0937 9.85289 9.51043Z"
                  fill="#CCCCCC"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M12.6666 17.9298C10.7704 17.9298 9.23323 19.4769 9.23323 21.3853C9.23323 21.4225 9.23636 21.4526 9.24052 21.475C9.24108 21.478 9.24164 21.4808 9.24219 21.4834C9.73861 21.7599 11.1434 22.2954 14.5003 22.2954C17.8572 22.2954 19.262 21.7599 19.7585 21.4834C19.759 21.4808 19.7596 21.478 19.7601 21.475C19.7643 21.4526 19.7674 21.4225 19.7674 21.3853C19.7674 19.4769 18.2302 17.9298 16.334 17.9298H12.6666ZM7.37426 21.3853C7.37426 18.4436 9.74374 16.0588 12.6666 16.0588H16.334C19.2569 16.0588 21.6264 18.4436 21.6264 21.3853C21.6264 21.9102 21.4497 22.654 20.7474 23.0694C19.8941 23.5741 18.1332 24.1663 14.5003 24.1663C10.8674 24.1663 9.1065 23.5741 8.25322 23.0694C7.55099 22.654 7.37426 21.9102 7.37426 21.3853Z"
                  fill="#CCCCCC"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M20.1094 6.77173C20.2434 6.27297 20.7537 5.97792 21.2492 6.11272C22.9455 6.57412 24.105 8.25064 24.105 10.1341C24.105 12.1247 22.7477 13.9466 20.8078 14.1812C20.2981 14.2428 19.8353 13.8769 19.7741 13.3639C19.7128 12.851 20.0764 12.3852 20.5861 12.3236C21.4346 12.221 22.2461 11.3461 22.2461 10.1341C22.2461 8.98353 21.5466 8.13171 20.7642 7.91889C20.2687 7.78409 19.9755 7.27049 20.1094 6.77173Z"
                  fill="#CCCCCC"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M22.2632 16.8152C22.3615 16.3081 22.8496 15.9772 23.3535 16.0761C25.2296 16.4444 26.5837 18.0986 26.5837 20.0224V20.5282C26.5837 21.0083 26.4406 21.7338 25.7745 22.1623C25.3581 22.4302 24.727 22.7062 23.773 22.9005C23.2698 23.0029 22.7794 22.6754 22.6776 22.1691C22.5758 21.6627 22.9012 21.1691 23.4043 21.0666C24.1119 20.9226 24.5117 20.7414 24.7177 20.6201L24.718 20.6184C24.7218 20.5959 24.7247 20.5657 24.7247 20.5282V20.0224C24.7247 18.9938 24.0007 18.1094 22.9976 17.9125C22.4938 17.8136 22.165 17.3223 22.2632 16.8152Z"
                  fill="#CCCCCC"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8.89121 13.4964C8.75727 13.9952 8.24696 14.2902 7.7514 14.1554C6.05519 13.6941 4.89562 12.0175 4.89562 10.1341C4.89562 8.14351 6.25297 6.32152 8.19289 6.087C8.70257 6.02538 9.16537 6.39127 9.2266 6.90424C9.28782 7.4172 8.92428 7.88299 8.4146 7.94461C7.56606 8.04719 6.7546 8.9221 6.7546 10.1341C6.7546 11.2846 7.45401 12.1365 8.23643 12.3493C8.73199 12.4841 9.02514 12.9977 8.89121 13.4964Z"
                  fill="#CCCCCC"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M6.73741 16.8152C6.63915 16.3081 6.15104 15.9772 5.64719 16.0761C3.77105 16.4444 2.41699 18.0986 2.41699 20.0224V20.5282C2.41699 21.0083 2.56004 21.7338 3.22619 22.1623C3.64258 22.4302 4.27363 22.7062 5.22769 22.9005C5.73084 23.0029 6.22124 22.6754 6.32304 22.1691C6.42483 21.6627 6.09947 21.1691 5.59632 21.0666C4.8887 20.9226 4.48894 20.7414 4.28294 20.6201L4.28266 20.6184C4.27882 20.5959 4.27597 20.5657 4.27597 20.5282V20.0224C4.27597 18.9938 4.99993 18.1094 6.00303 17.9125C6.50688 17.8136 6.83567 17.3223 6.73741 16.8152Z"
                  fill="#CCCCCC"
                />
              </svg>
            </div>
            <div>
              <div className="text-[14px]">
                Etkinlikteki Story’leri görüntüle
              </div>
              <div className="text-[11px] text-[#71757E]">
                Bir story paylaş veya story’leri görüntüle.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
